
export function stripHTML(htmlString: string = ""): string {
  if (!htmlString) return "";

  const clean = htmlString;

  return clean.replace(/<\/?[^>]+(>|$)/g, "");
}

export function stripHTMLKeepBreak(htmlString: string = ""): string {
  if (!htmlString) return "";

  let clean = htmlString;

  clean = clean.replace(/<br\s*\/?>/gi, "\n");
  clean = clean.replace(/<\/?[^>]+(>|$)/g, "");

  return clean.trim();
}

export function stripHTMLKeepBreakWithFont(
  htmlString: string = "",
  font: string = "Montserrat",
): string {
  if (!htmlString) return "";

  let clean = htmlString;

  clean = clean.replace(/<br\s*\/?>/gi, "<br/>");
  clean = clean.replace(/<\/?[^>]+(>|$)/g, "");

  return `<div style="font-family: '${font}', sans-serif; white-space: pre-line;">${clean}</div>`;
}

export function sanitizeHTMLKeepStyleWithFont(
  htmlString: string = "",
  font: string = "Montserrat",
): string {
  if (!htmlString) return "";

  let clean = htmlString;

  // Xóa các inline font-family, font-size, line-height do CMS / editor gán để typography theo component
  clean = clean.replace(/font-family\s*:[^;"]+;?/gi, "");
  clean = clean.replace(/font-size\s*:[^;"]+;?/gi, "");
  clean = clean.replace(/line-height\s*:[^;"]+;?/gi, "");

  // Chuẩn hóa khoảng trắng style rỗng
  clean = clean.replace(/style="\s*"/gi, "");
  clean = clean.replace(/style=";\s*"/gi, "");

  return clean;
}

/**
 * Làm sạch HTML mô tả sản phẩm:
 * - Giữ lại các thẻ trang trí nhẹ: <b>, <strong>, <i>, <em>, <u>, <br>, <p>, <ul>, <ol>, <li>
 * - Loại bỏ toàn bộ inline font-family, font-size, color, line-height cứng để font chữ và kích thước tuân theo component
 * - Chuyển đổi xuống dòng thuần túy (\n) thành <br/> nếu chuỗi không có thẻ bao quanh
 */
export function formatProductContent(htmlString: string = ""): string {
  if (!htmlString) return "";

  let clean = htmlString.trim();

  // Nếu text thuần túy không chứa HTML tag, chuyển \n thành <br/>
  if (!/<[a-z][\s\S]*>/i.test(clean)) {
    return clean.replace(/\r?\n/g, "<br />");
  }

  // Xóa bỏ các style ép buộc font-family, font-size, line-height, color cứng của CMS
  clean = clean.replace(/font-family\s*:[^;"]+;?/gi, "");
  clean = clean.replace(/font-size\s*:[^;"]+;?/gi, "");
  clean = clean.replace(/line-height\s*:[^;"]+;?/gi, "");

  // Dọn dẹp thuộc tính style rỗng
  clean = clean.replace(/style="\s*"/gi, "");
  clean = clean.replace(/style=";\s*"/gi, "");

  // Chuẩn hóa cấu trúc bảng để tránh lỗi React Hydration mismatch từ Word/CMS (như nested tbody, khoảng trắng giữa thẻ bảng)
  clean = clean.replace(/<tbody[^>]*>\s*<tbody[^>]*>/gi, "<tbody>");
  clean = clean.replace(/<\/tbody>\s*<\/tbody>/gi, "</tbody>");
  clean = clean.replace(
    /(<\/?(?:table|tbody|thead|tfoot|tr)[^>]*>)\s+(<\/?(?:table|tbody|thead|tfoot|tr|td|th)[^>]*>)/gi,
    "$1$2"
  );
  clean = clean.replace(
    /(<\/?(?:table|tbody|thead|tfoot|tr)[^>]*>)\s+(<\/?(?:table|tbody|thead|tfoot|tr|td|th)[^>]*>)/gi,
    "$1$2"
  );

  return clean;
}

export interface ParsedProductHTML {
  links: any[] | null;
  descriptionHTML: string;
}

export function parseStructuredListFromHTML<T = any>(
  rawHTML = "",
  {
    itemDelimiter = "***",
    fieldDelimiter = "::",
    fields = [] as ReadonlyArray<keyof T> | (keyof T)[],
    strip = stripHTML,
  }: {
    itemDelimiter?: string;
    fieldDelimiter?: string;
    fields?: ReadonlyArray<keyof T> | (keyof T)[];
    strip?: (html: string) => string;
  } = {},
): T[] {

  if (!rawHTML) return [];

  const clean = strip(rawHTML);

  return clean
    .split(itemDelimiter)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => {
      const parts = item.split(fieldDelimiter).map((p) => p.trim());

      // If schema provided → map to object
      if (fields.length) {
        const obj = {} as T;

        fields.forEach((key, index) => {
          (obj as any)[key] = parts[index] !== undefined ? parts[index] : null;
        });

        return obj;
      }


      // Fallback → return raw array
      return parts;
    }) as any;
}

